// Minimal POSIX ustar tar writer for building npm package tarballs in the
// browser. npm requires entries prefixed with "package/"; callers pass paths
// already including that prefix. Only regular files are supported (no dirs,
// symlinks, or long-name extensions) — sufficient for our flat package.

function encodeStr(str) { return new TextEncoder().encode(str) }

function writeOctal(view, offset, value, length) {
  // ustar numeric fields: zero-padded octal, NUL-terminated, `length` bytes.
  const s = value.toString(8).padStart(length - 1, '0') + '\0'
  const bytes = encodeStr(s)
  view.set(bytes.subarray(0, length), offset)
}

function header(name, size) {
  const buf = new Uint8Array(512)
  buf.set(encodeStr(name).subarray(0, 100), 0)   // name
  writeOctal(buf, 100, 0o644, 8)                 // mode
  writeOctal(buf, 108, 0, 8)                     // uid
  writeOctal(buf, 116, 0, 8)                     // gid
  writeOctal(buf, 124, size, 12)                 // size
  writeOctal(buf, 136, 0, 12)                    // mtime (fixed 0 → deterministic)
  buf.set(encodeStr('        '), 148)            // checksum field = spaces pre-calc
  buf[156] = 0x30                                // typeflag '0' = regular file
  buf.set(encodeStr('ustar\0'), 257)             // magic
  buf.set(encodeStr('00'), 263)                  // version
  let sum = 0
  for (let i = 0; i < 512; i++) sum += buf[i]
  writeOctal(buf, 148, sum, 8)                   // real checksum
  return buf
}

// files: Array<{ name: string, data: Uint8Array }>
export function buildTar(files) {
  const blocks = []
  for (const f of files) {
    blocks.push(header(f.name, f.data.length))
    blocks.push(f.data)
    const pad = (512 - (f.data.length % 512)) % 512
    if (pad) blocks.push(new Uint8Array(pad))
  }
  blocks.push(new Uint8Array(1024)) // two zero blocks = archive end
  const total = blocks.reduce((n, b) => n + b.length, 0)
  const out = new Uint8Array(total)
  let off = 0
  for (const b of blocks) { out.set(b, off); off += b.length }
  return out
}
